import React from 'react';
import PropTypes from 'prop-types';
import { RequestBudgetCheck } from '../../../shared/svg/components';
import { TranslationUtility } from '../../../utilities/TranslationUtility';

const BudgetStatus = ({ isRequestBudget, includesPrices }) => {
    const getBudgetStatusText = () => {
        if (isRequestBudget) {
            return TranslationUtility.GetFormattedMessageForUI('ui-printing-budget-requested',
                'Presupuesto formalizado');
        }

        return TranslationUtility.GetFormattedMessageForUI('ui-printing-budget-draft',
            'Presupuesto borrador');
    };

    const getBudgetSubtitleText = () => {
        if (isRequestBudget && !includesPrices) {
            return '(sin precios)';
        }

        return '';
    };

    return (
      <div className="budget-status">
        <div className="background">
          <div className="title">{getBudgetStatusText()}</div>
          <div className="subtitle">{getBudgetSubtitleText()}</div>
          {isRequestBudget && includesPrices
              ? (<div className="check"><RequestBudgetCheck className="icon" /></div>) : null}
        </div>
      </div>
    );
};

BudgetStatus.propTypes = {
    isRequestBudget: PropTypes.bool.isRequired,
    includesPrices: PropTypes.bool.isRequired,
};

export default BudgetStatus;
